module.exports = __webpack_public_path__ + "img/ic_round-double-arrow.44fa39db.svg";